import React from "react";

const EaseCruise = (props)=> {
    return(
        <>
        <div className="ease-container">
        <div>
        <img src={props.icon} alt="Why choose Int2cruises"></img> 
       </div>
        <h3>{props.heading}</h3>
        <p>{props.content}</p>
        </div>
        </>
    );

}

export default EaseCruise;